module.exports = __webpack_public_path__ + "img/web5.b7ee6612.webp";